import * as actions from "./actions";

const initialState = {
	item: null,
	loading: {}
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.GET_CLIENT: {
			return {
				...state,
				loading: { get: true }
			};
		}
		case actions.GET_CLIENT_SUCCESS: {
			return {
				...state,
				item: payload,
				loading: { get: false }
			};
		}
		case actions.GET_CLIENT_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { get: false }
			};
		}

		case actions.QUERY_CLIENT_MEI: {
			return {
				...state,
				loading: { query: true }
			};
		}
		case actions.QUERY_CLIENT_MEI_SUCCESS: {
			return {
				...state,
				loading: { query: false }
			};
		}
		case actions.QUERY_CLIENT_MEI_FAILED: {
			return {
				...state,
				loading: { query: false },
				errors: payload
			};
		}

		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
